import { combineReducers } from 'redux';
import { includes, pathOr } from 'ramda';

import { actions } from '../actions/auth';

const isAuthenticated = (state = false, action) => {
  switch (action.type) {
    case actions.AUTHENTICATION_LOGIN_SUCCESS:
      return true;
    case actions.AUTHENTICATION_LOGIN_FAILED:
    case actions.AUTHENTICATION_LOGOUT_SUCCESS:
      return false;
    case actions.AUTHENTICATION_CHECK_SESSION_SUCCESS:
      return !!action.payload.user;
    default:
      return state;
  }
}

const user = (state = null, action) => {
  switch (action.type) {
    case actions.AUTHENTICATION_CHECK_SESSION_SUCCESS:
    case actions.AUTHENTICATION_LOGIN_SUCCESS:
      return Object.assign({}, action.payload.user);
    case actions.AUTHENTICATION_CHECK_SESSION_REQUEST:
    case actions.AUTHENTICATION_LOGIN_REQUEST:
    case actions.AUTHENTICATION_LOGOUT_SUCCESS:
    case actions.AUTHENTICATION_LOGIN_FAILED:
      return null;
    default:
      return state;
    
  }
};

const bootingSession = (state = false, action) => {
  switch (action.type) {
    case actions.AUTHENTICATION_CHECK_SESSION_REQUEST:
      return true;
    case actions.AUTHENTICATION_CHECK_SESSION_SUCCESS:
      return false;
    default:
      return state;
  }
};

const isAdministrator = (state = false, action) => {
  switch (action.type) {
    case actions.AUTHENTICATION_CHECK_SESSION_SUCCESS:
    case actions.AUTHENTICATION_LOGIN_SUCCESS:
      return includes('password', pathOr([], ['user', 'providers'], action.payload));
    case actions.AUTHENTICATION_LOGOUT_SUCCESS:
      return false;
    default:
      return state;
  }
}

const loading = (state = false, action) => {
  switch (action.type) {
    case actions.AUTHENTICATION_LOGIN_REQUEST:
    case actions.AUTHENTICATION_LOGOUT_REQUEST:
      return true;
    case actions.AUTHENTICATION_LOGIN_SUCCESS:
    case actions.AUTHENTICATION_LOGIN_FAILED:
    case actions.AUTHENTICATION_LOGOUT_SUCCESS:
    case actions.AUTHENTICATION_LOGOUT_FAILED:
      return false;
    default: 
      return state;
  }
};

const auth = combineReducers({
  isAuthenticated,
  bootingSession,
  user,
  isAdministrator,
  loading,
});

export default auth;

export const isAuthenticatedSelector = state => state.auth.isAuthenticated;
export const isBootingSessionSelector = state => state.auth.bootingSession;
export const isAdministratorSelector = state => state.auth.isAdministrator;
export const authenticatedUserSelector = state => state.auth.user;
export const isLoadingSelector = state => state.auth.loading;
